import { z } from "zod"
import { TranslationKey } from "../i18n/translation-key"
import { ProductSchema } from "../pos"
import { LegacyCompatibleDiscountSchema } from "./discount"
import { ProductChoiceSchema } from "./evaluated-service-bike-part"

export const ManualServiceActionSchema = z.object({
  id: z.guid(),
  title: z
    .string()
    .min(1, "common.validation.nameRequired" satisfies TranslationKey),
  description: z.string().optional(),
  laborPrice: z.number().min(0),
  laborPriceDiscount: LegacyCompatibleDiscountSchema.nullable().default(null),
  products: z.array(ProductSchema),
  productChoices: z.array(ProductChoiceSchema).default([]),
  isMandatory: z.boolean(),
  requiredWashId: z.guid().optional(),
  requiredPartIds: z.array(z.guid()),
  requiredManualServiceActionIds: z.array(z.guid()),
  /**
   * Custom booking section item the action was made from, so the reception
   * summary can tell a booked add-on made it into the work order. Omitted by
   * callers that don't know about custom items, which leaves a saved link as is.
   */
  customBookingSectionItemId: z.guid().nullable().optional(),
})

export type ManualServiceAction = z.infer<typeof ManualServiceActionSchema>
